/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Combo_Parent_Not_ComboInputs */

const vi_error_combo_parent_not_combo = /** @type {(inputs: Error_Combo_Parent_Not_ComboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm này không phải combo nên không có công thức thành phần.`)
};

/**

* @param {Error_Combo_Parent_Not_ComboInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_combo_parent_not_combo = /** @type {((inputs?: Error_Combo_Parent_Not_ComboInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Combo_Parent_Not_ComboInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_combo_parent_not_combo(inputs)
});